import type { MaskOptions } from '@react-input/mask';

import type { DataAttributesProps } from '../utils/types';

import { cn } from '@polyseme/utils/cn/cn-utils';
import { useMask } from '@react-input/mask';
import mergeRefs from 'merge-refs';
import * as React from 'react';

export type InputProps = DataAttributesProps &
  React.ComponentProps<'input'> & {
    mask?: MaskOptions;
  };

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, 'data-testid': dataTestId, mask, type, ...props }, ref) => {
    const inputRef = useMask(mask);

    return (
      <input
        ref={mask ? mergeRefs(ref, inputRef) : ref}
        className={cn(
          'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          className
        )}
        type={type}
        {...props}
        data-testid={dataTestId ?? props.name}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
